export default {
  isLoading: false,
  listaPrestaciones: [],
  filtros: null,
  viewDetails: false,
  lastPrestacion: null,
  linkPdfPrestacion: null,
};
